import { defineField, defineType } from 'sanity'
import getPageInfo, { seoGroup } from '../../objects/pageInfo'

export default defineType({
  title: 'Gallery',
  name: 'gallery',
  type: 'document',
  groups: [
    {
      name: 'content',
      title: 'Content',
      default: true,
    },
    seoGroup,
  ],
  fields: [
    getPageInfo({ lockCanonical: true }),
    defineField({
      title: 'Hero',
      name: 'hero',
      type: 'hero',
      group: 'content',
    }),
  ],
  preview: {
    select: {
      pageInfo: 'pageInfo',
    },
    prepare(selection) {
      const { title = 'New Page', description: subtitle = '' } =
        selection.pageInfo || {}
      return {
        title,
        subtitle,
      }
    },
  },
})